import Swiper from 'swiper';
import decodeEntities from 'extensions/decode-entities/decode-entities';
import uid from 'extensions/uid/uid';

function checkNavigationElement( container, element ) {

	let navigationElement = container.querySelector( element );

	// If it doesn't exist check the parent container
	if (!navigationElement) {
		navigationElement = container.parentElement.querySelector( element );
	}

	return navigationElement;

};

export function makeNaviagationElementsUnique( uid, container, parameters ) {

	// find default parameters
	if ( parameters && parameters.navigation ) {

		// check for navigation elements, add a class and update the selector
		if ( parameters.navigation.nextEl ) {

			let navigationEl = checkNavigationElement( container, parameters.navigation.nextEl );

			if ( navigationEl ) {
				navigationEl.classList.add( uid );
				parameters.navigation.nextEl += `.${ uid }`;
			}

		}

		if ( parameters.navigation.prevEl ) {

			let navigationEl = checkNavigationElement( container, parameters.navigation.prevEl );
			
			if ( navigationEl ) {
				navigationEl.classList.add( uid );
				parameters.navigation.prevEl += `.${ uid }`;
			}

		}

	}

	// loop through breakpoints
	if ( parameters && parameters.breakpoints ) {

		for ( let breakpoint in parameters.breakpoints ) {
			
			parameters.breakpoints[ breakpoint ] = makeNaviagationElementsUnique( uid, container, parameters.breakpoints[ breakpoint ] );


		}

	}

	return parameters;

};

export class Carousel {

	constructor( element, parameters ) {

		if ( typeof Swiper === 'undefined' ) {
			throw new Error( '[Carousel].constructor - Missing dependancy "Swiper".' );
		}

		if ( element == null ) {
			console.warn( '[Carousel].constructor - Element does not exist.' );
			return false;
		}

		this.container = element.querySelector( '.swiper-container' );

		if ( this.container == null ) {
			throw new Error( '[Carousel].constructor - Unable to find `swiper-container` element.' );
		}

		// create uid
		this.uid = uid();

		this.defaultParameters = {
			slidesPerView: 2.375,
			spaceBetween: 20,
			loop: false,
			breakpoints: {
				960: {
					slidesPerView: 4,
					slidesPerGroup: 4,
					spaceBetween: 35,
					navigation: {
						nextEl: `.swiper-button-next`,
						prevEl: `.swiper-button-prev`
					},
					pagination: {
						el: '.swiper-pagination',
						clickable: true
					}
				},
				768: {
					slidesPerView: 2.375,
					spaceBetween: 10
				}
			}
		};

		this.parameters = makeNaviagationElementsUnique( this.uid, this.container, ( parameters ) ? parameters : this.defaultParameters );
		
		this.init();

	}

	destroy() {

		if ( !this.container.classList.contains( 'swiper-container-initialized' ) ) {
			return false;
		}

		if ( this.slider ) {
			this.slider.destroy();
		}

		return true;

	}

	init() {
		
		this.destroy();
		this.slider = new Swiper( this.container, this.parameters );

	}
	
}

function initializeCarousel( element ) {
	
	let parameters = ( element.dataset.carouselParameters.length ) ? JSON.parse( decodeEntities( element.dataset.carouselParameters ) ) : undefined;

	new Carousel( element, parameters );

}

export function initializeCarousels() {

	const carouselElements = document.getElementsByClassName( 'js-carousel' );

	for ( let element of carouselElements ) {

		if ( element.classList.contains( 'lazyloaded' ) || !element.classList.contains( 'lazyload' ) ) {

			initializeCarousel( element );

		}

	}

	document.addEventListener(
		'lazybeforeunveil', 
		( e ) => {

			if ( e.target.classList.contains( 'js-carousel' ) ) {

				initializeCarousel( e.target );

			}

		}
	);

}
